<template>
    <AppLayout>
        <div class="container relative h-screen p-4 mx-auto md:px-1 md:py-4">
            <!-- breadcrumb -->
            <nav
                class="mb-6 text-sm font-semibold"
                aria-label="Breadcrumb"
            >
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-blue-500">
                        <inertia-link
                            :href="route('landing')"
                            class="text-gray-600"
                        >
                            Home
                        </inertia-link>
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3 "
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a
                            href="#"
                            class="text-gray-600"
                        >Chat</a>
                    </li>
                </ol>
            </nav>
            <!-- breadcrumb end -->

            <!-- title -->
            <div class="flex justify-between mb-6">
                <div class="font-extrabold md:text-2xl">
                    Messages
                </div>
            </div>

            <div class="flex gap-2 h-3/4">
                <!-- user list -->
                <div class="flex-shrink-0 hidden w-1/3 px-4 py-2 bg-white rounded shadow md:block">
                    <Multiselect
                        v-model="retailer"
                        class="mb-4"
                        :options="retailers"
                        placeholder="Choose Retailer"
                        label="name"
                        track-by="name"
                    />
                    <Multiselect
                        v-model="wholesaler"
                        class="mb-4"
                        :options="wholesalers"
                        placeholder="Choose Wholesaler"
                        label="name"
                        track-by="name"
                    />
                </div>

                <!-- currentMessages -->
                <div class="flex-grow h-full bg-white rounded shadow">
                    <div class="flex flex-col h-full">
                        <div class="flex items-center justify-between">
                            <div
                                v-if="retailer"
                                class="px-4 py-3 font-bold border-b md:text-xl"
                            >
                                {{ retailer.name }}
                            </div>

                            <div
                                v-if="wholesaler"
                                class="px-4 py-3 font-bold border-b md:text-xl"
                            >
                                {{ wholesaler.name }}
                            </div>
                        </div>

                        <ChatMessages
                            id="chat-messages"
                            ref="chatmessagesref"
                            :messages="currentMessages"
                            :wholesaler="wholesaler"
                            class="p-2 mt-auto overflow-y-scroll"
                        />
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import Multiselect from 'vue-multiselect';
import AppLayout from '../../Layouts/AppLayout.vue';
import ChatMessages from '../../Components/ChatMessages.vue';

export default {
    name: 'AdminIndex',

    components: {
        AppLayout,
        ChatMessages,
        Multiselect,
    },

    props: {
        users: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            retailer: null,
            wholesaler: null,
            currentMessages: [],
            currentMessagesPaginationData: null,
            loadingMoreMessages: false,
        };
    },

    computed: {
        retailers() {
            return this.users.filter((user) => user.roles.find((role) => role.name === 'retailer'));
        },
        wholesalers() {
            return this.users.filter((user) => user.roles.find((role) => role.name === 'wholesaler'));
        },
    },

    watch: {
        wholesaler: {
            deep: true,
            handler() {
                if (this.wholesaler != null && this.retailer != null) {
                    this.fetchCurrentUserMessaged();
                }
            },
        },
        retailer: {
            deep: true,
            handler() {
                if (this.wholesaler != null && this.retailer != null) {
                    this.fetchCurrentUserMessaged();
                }
            },
        },
    },

    mounted() {
        this.fetchMoreCurrentUserMessaged();
    },

    methods: {
        fetchCurrentUserMessaged() {
            const messageBlock = document.getElementById('chat-messages');
            this.$axios.get(route('chat.fetchMessages', { userId: this.wholesaler.id, user2Id: this.retailer.id })).then((res) => {
                this.currentMessagesPaginationData = res.data.messages;
                this.currentMessages = res.data.messages.data.sort((a, b) => {
                    const dateA = new Date(a.created_at);
                    const dateB = new Date(b.created_at);
                    return dateA - dateB;
                });
            }).then(() => {
                messageBlock.scrollTo(0, 400);
            });
        },

        // this function does not fetch more messages on mount
        // instead it sets up a event on scroll of message box to fetch more messages.
        async fetchMoreCurrentUserMessaged() {
            const messageBlock = document.getElementById('chat-messages');
            messageBlock.onscroll = () => {
                if (messageBlock.scrollTop === 0 && !this.loadingMoreMessages && this.currentMessages.length !== this.currentMessagesPaginationData.total) {
                    console.log('here');
                    this.loadingMoreMessages = true;
                    const scrollPositionMessage = this.currentMessages[0];
                    this.$axios.get(route('chat.fetchMessages', { userId: this.wholesaler.id, user2Id: this.retailer.id, page: this.currentMessagesPaginationData.current_page + 1 })).then((res) => {
                        this.currentMessagesPaginationData = res.data.messages;
                        this.currentMessages = [...res.data.messages.data, ...this.currentMessages].sort((a, b) => {
                            const dateA = new Date(a.created_at);
                            const dateB = new Date(b.created_at);
                            return dateA - dateB;
                        });
                        this.loadingMoreMessages = false;

                        const target = document.getElementById(`message-${scrollPositionMessage.id}`);
                        target.parentNode.scrollTop = target.offsetTop - 110;
                    }).catch(() => {
                        this.loadingMoreMessages = false;
                        console.log('Something went wrong while fetching data.');
                    });
                }
            };
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
